import * as React from "react"
import { cva } from "class-variance-authority"
import { cn } from "../../lib/utils"
import { 
  AlertCircle,
  AlertTriangle,
  CheckCircle2,
  Info,
  HelpCircle,
  Bell
} from "lucide-react"

const icons = {
  default: HelpCircle,
  primary: Bell,
  secondary: Info,
  accent: Info,
  neutral: Info,
  success: CheckCircle2,
  warning: AlertTriangle,
  info: Info,
  blue: Info,
  destructive: AlertCircle,
}

const alertVariants = cva(
  "relative w-full rounded-lg p-4 [&>svg~*]:pl-7 [&>svg+div]:translate-y-[-3px] [&>svg]:absolute [&>svg]:left-4 [&>svg]:top-4 [&>svg]:text-white",
  {
    variants: {
      variant: {
        default: "bg-slate-900/10 text-slate-900 dark:bg-slate-50/10 dark:text-slate-50 shadow-sm",
        primary: "bg-indigo-500/90 text-white shadow-sm",
        secondary: "bg-slate-600/90 text-white shadow-sm",
        accent: "bg-violet-500/90 text-white shadow-sm",
        neutral: "bg-slate-500/90 text-white shadow-sm",
        success: "bg-green-500/90 text-white shadow-sm",
        warning: "bg-yellow-500/90 text-white shadow-sm",
        info: "bg-sky-500/90 text-white shadow-sm",
        blue: "bg-blue-500/90 text-white shadow-sm",
        destructive: "bg-red-500/90 text-white shadow-sm",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

const Alert = React.forwardRef(({ className, variant = "default", ...props }, ref) => {
  const Icon = icons[variant]

  return (
    <div
      ref={ref}
      role="alert"
      className={cn(alertVariants({ variant }), className)}
      {...props}
    >
      {Icon && <Icon className="h-4 w-4" />}
      {props.children}
    </div>
  )
})
Alert.displayName = "Alert"


const AlertTitle = React.forwardRef(({ className, ...props }, ref) => (
  <h5
    ref={ref}
    className={cn("mb-1 font-medium leading-none tracking-tight", className)}
    {...props}
  />
))
AlertTitle.displayName = "AlertTitle"

const AlertDescription = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn("text-sm [&_p]:leading-relaxed", className)}
    {...props}
  />
))
AlertDescription.displayName = "AlertDescription"

export { Alert, AlertTitle, AlertDescription }